import { render, staticRenderFns } from "./detail_basic.vue?vue&type=template&id=da6c9c30"
import script from "./detail_basic.vue?vue&type=script&lang=js"
export * from "./detail_basic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('da6c9c30')) {
      api.createRecord('da6c9c30', component.options)
    } else {
      api.reload('da6c9c30', component.options)
    }
    module.hot.accept("./detail_basic.vue?vue&type=template&id=da6c9c30", function () {
      api.rerender('da6c9c30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "found/views/tpm/views/pay_center/write_off/components/write_off_details/visitDetail/components/detail_basic.vue"
export default component.exports